import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import $ from 'jquery';
import { REASONS } from '../../../assets/constants/strings';
import './style.scoped.scss';

const CancelSubscriptionReason = ({ handleCancel }) => {

  const [selectedReason, setSelectedReason] = useState(null);
  const [textArea, setTextArea] = useState('');

  const submit = () => {
    setSelectedReason(null);
    setTextArea('');
    handleCancel(selectedReason, textArea);
  };

  const clear = () => {
    setSelectedReason(null);
    setTextArea('');
    $('#cancelReasonModal').modal('hide');
  }

  return (
    <div
      className="modal"
      id="cancelReasonModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div className="modal-content expiry cancel">
          <div className="svg-close" onClick={clear}>
            <FaTimes />
          </div>
          <div className="modal-body cancelReasonModal">
            <h4 className="sad">Unsubscribe Successful!</h4>

            <b>If you have a moment, please let us know why you unsubscribed. We’ll use this feedback to improve Regulation City.</b>

            <div className="form" id="reasons">
              {REASONS.map((reason, i) => (
                <div className="form-group my-2 d-flex align-items-center" key={i}>
                  <input
                    id={`reason-${i}`}
                    type="radio"
                    name="reasons"
                    checked={reason === selectedReason}
                    onChange={() => setSelectedReason(reason)}
                  />
                  <label htmlFor={`reason-${i}`} className="mb-0 ml-2">{reason}</label>
                </div>
              ))}
            </div>

            <textarea
              className="w-100 p-2"
              value={textArea}
              onChange={(e) => setTextArea(e.target.value)}
              placeholder="Please tell us more so we can improve our offering..."
            />

            <div className="buttons-row">
              <button
                className="my-account-btn"
                disabled={!selectedReason}
                type="button"
                onClick={submit}
              >
                Submit
              </button>
              <button
                className="my-account-btn secondary"
                type="button"
                onClick={clear}
              >
                Skip
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionReason;
